import { orgRequest } from '@/api/orgClient'
import { env } from '@/config/env'

export interface ExchangeTokenReq {
  code: string
  state?: string
  redirect_uri?: string
}

export interface TokenInfo {
  token: string
  access_token?: string
  user_id?: string
  name?: string
}

/**
 * OAuth 回调换 token。
 * 授权页走统一 Hydra（VITE_AUTH_URL）；换码打 org-server
 *（`VITE_ORG_API_BASE_URL`），body 带 `client_id`。
 */
export function exchangeToken(body: ExchangeTokenReq) {
  return orgRequest<TokenInfo>('/oauth/token', {
    method: 'POST',
    body: {
      code: body.code,
      state: body.state,
      redirect_uri: body.redirect_uri,
      client_id: env.oauthClientId,
    },
    skipAuth: true,
  })
}
